import React from 'react';
import { createPortal } from 'react-dom';

const MetricHelpIcon = ({ text, id }) => {
  const buttonRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [style, setStyle] = React.useState(null);

  const updatePosition = React.useCallback(() => {
    const el = buttonRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setStyle({
      top: Math.max(8, rect.top - 8),
      left: rect.left + rect.width / 2,
    });
  }, []);

  const show = () => {
    updatePosition();
    setOpen(true);
  };

  const hide = () => setOpen(false);

  React.useEffect(() => {
    if (!open) return undefined;
    const reposition = () => updatePosition();
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
    return () => {
      window.removeEventListener('scroll', reposition, true);
      window.removeEventListener('resize', reposition);
    };
  }, [open, updatePosition]);

  if (!text) return null;

  const tooltipId = id || `metric-help-${text.slice(0, 24).replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="dashboard-metric-help-btn"
        aria-label={text}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <i className="ri-question-line" aria-hidden="true" />
      </button>
      {open && style && createPortal(
        <div
          id={tooltipId}
          role="tooltip"
          className="dashboard-metric-help-popup"
          style={{
            top: style.top,
            left: style.left,
          }}
        >
          {text}
        </div>,
        document.body
      )}
    </>
  );
};

export default MetricHelpIcon;
